import { render, staticRenderFns } from "./IconoHeaderPuntual.vue?vue&type=template&id=1843075f&scoped=true&"
import script from "./IconoHeaderPuntual.vue?vue&type=script&lang=js&"
export * from "./IconoHeaderPuntual.vue?vue&type=script&lang=js&"
import style0 from "./IconoHeaderPuntual.vue?vue&type=style&index=0&id=1843075f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843075f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
